module.exports = __webpack_public_path__ + "img/ic_pin_rd.34b910be.svg";